import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { AgentSummaryDto } from 'src/generated-api-client';
import { AgentsListItem } from 'src/pages/AgentsPage/AgentsListItem';
import { AgentsPageHeaderPanel } from 'src/pages/AgentsPage/AgentsPageHeaderPanel';
import { AgentsStore } from 'src/stores/AgentsStore/AgentsStore';

export const AgentsPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="agents"
            store={store}
            asidePanel={<AgentsAsidePanel />}
            data-testid="agents-page"
        >
            <EntityPresentation store={store} entityName="agents" />
        </MasterDetailsPage>
    );
});

const AgentsAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: AgentSummaryDto) => {
                return (
                    <List.Item
                        key={item.id}
                        data-testid={`master-details-list-item-${item.id}`}
                    >
                        <AgentsListItem item={item} />
                    </List.Item>
                );
            }}
            header={<AgentsPageHeaderPanel />}
        />
    );
});

const store = AgentsStore;
